"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppVersion = void 0;
function getAppVersion() {
    var version = process.env.ARTIFACT_VERSION || '0.0.0';
    return version.replace('-SNAPSHOT', '');
}
exports.getAppVersion = getAppVersion;
//# sourceMappingURL=getAppVersion.js.map